import React from 'react';

export default function SunWatermark({ className = '', size = 400, opacity = 0.045 }) {
  const cx = size / 2;
  const cy = size / 2;
  const r = size * 0.15;
  const innerRay = size * 0.225;
  const outerRay = size * 0.42;
  const rayCount = 16;

  return (
    <svg
      className={`pointer-events-none select-none ${className}`}
      viewBox={`0 0 ${size} ${size}`}
      fill="currentColor"
      aria-hidden="true"
      width={size}
      height={size}
      style={{ opacity }}
    >
      {/* Core circle */}
      <circle cx={cx} cy={cy} r={r} />

      {/* Inner ring */}
      <circle cx={cx} cy={cy} r={r * 1.55} fill="none" stroke="currentColor" strokeWidth={size * 0.004} />

      {/* Rays — alternating long and short */}
      {[...Array(rayCount)].map((_, i) => {
        const angle = (i * (360 / rayCount) * Math.PI) / 180;
        const isLong = i % 2 === 0;
        const start = isLong ? innerRay : innerRay * 1.1;
        const end = isLong ? outerRay : outerRay * 0.72;
        const x1 = cx + start * Math.cos(angle);
        const y1 = cy + start * Math.sin(angle);
        const x2 = cx + end * Math.cos(angle);
        const y2 = cy + end * Math.sin(angle);
        return (
          <line
            key={i}
            x1={x1} y1={y1}
            x2={x2} y2={y2}
            stroke="currentColor"
            strokeWidth={isLong ? size * 0.012 : size * 0.007}
            strokeLinecap="round"
          />
        );
      })}

      {/* Outer decorative ring */}
      <circle
        cx={cx} cy={cy}
        r={outerRay + size * 0.03}
        fill="none"
        stroke="currentColor"
        strokeWidth={size * 0.002}
        strokeDasharray={`${size * 0.018} ${size * 0.022}`}
      />
    </svg>
  );
}
